import { useQuery } from '@apollo/client';
import useReportQueryParams from 'components/ReportsModule/hooks/use-report-query-params';
import { baseVars } from 'graph/apollo-util';
import GET_ORGANIZATION_ENGAGEMENT_OVERVIEW_REPORT from 'graph/reports/get-organization-engagement-overview-report';
import { GetOrganizationEngagmentOverviewReportQuery } from 'types/schema-generated-types';

const useDistrictOverview = () => {
  const [{ entityId: organizationId, productFamilyCode }] = useReportQueryParams();
  const { data } = useQuery<GetOrganizationEngagmentOverviewReportQuery>(
    GET_ORGANIZATION_ENGAGEMENT_OVERVIEW_REPORT,
    baseVars({
      organizationId,
      licenseUsageWhere: {
        productFamily: {
          code: productFamilyCode
        }
      }
    })
  );

  return [
    { prmOrganizationEngagementOverviewReport: data?.prmOrganizationEngagementOverviewReport }
  ];
};

export default useDistrictOverview;
